module.exports = __webpack_public_path__ + "img/20220219_071537.1ec3984d.jpg";